module.exports = __webpack_public_path__ + "img/car_00041.4188d397.jpg";